import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "../views/Home.vue";
import Cinema from "../views/Cinema.vue";
import FirstDiagram from "../views/FirstDiagram.vue"
import Ova from "../views/ova.vue"
import About from "../views/About.vue"
import Diagram from "../components/Diagram.vue"

import Page404 from "../views/404"
Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "/about",
    children: [
      {
        path: '/about',
        name: 'About',
        component: About,
      },
      {
        path: '/Cinema',
        name: 'Cinema',
        component: Cinema,
      }, {
        path: '/FirstDiagram',
        name: 'FirstDiagram',
        component: FirstDiagram,
      },
      {
        path: '/Ova',
        name: 'Ova',
        component: Ova,
      },
      {
        path: '/Diagram',
        name: 'diagram',
        component: Diagram,
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: Page404
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
 
})
 
export default router

